// @flow
import React, {FunctionComponent, PropsWithChildren} from 'react';
import {Widget, WidgetTitle} from "../../Common";
import {JsonAnimal} from "../../../api/generated/rest-dto";
import {PregnancyListJson} from "../../../api/generated/medical-rest";
import {Pedigrees$ParentTypeValues as ParentTypeValues} from "../../../api/generated/herds-pedigree";
import MatingList from "./mating-list";
import {ChildFriendly} from "@mui/icons-material";

type Props = PropsWithChildren<{
    animal: JsonAnimal,
    matings: PregnancyListJson[]
}>;


const MatingWidget: FunctionComponent<Props> = ({animal,matings, children}) => {
    return (
        <Widget displayName={
            <WidgetTitle startIcon={<ChildFriendly color="error" />}>
                Deckungen
            </WidgetTitle>
        }>
            {matings.length
                ? <MatingList pregnancies={matings} baseParentKind={ParentTypeValues.SIRE}/>
                : 'Keine Deckungen vorhanden.'}
        </Widget>
    );
};

export default MatingWidget